export function getSpecData(spec, key) {
  if (!spec || !key) return null;
  const val = spec[key];
  if (key === 'pre_treatment_process') {
    const pt = spec.pre_treatment_process;
    if (pt && typeof pt === 'object') return Object.values(pt)[0] || null;
  }
  if (val && typeof val === 'object' && !Array.isArray(val)) return val;
  return val;
}

export function getTableData(specItem) {
  if (!specItem) return [];
  const d = specItem.data;
  if (Array.isArray(d)) return d;
  return [];
}
